import React from 'react';
import PropTypes from 'prop-types';

const SitecoreLinkField = (props) => {
    
	const hasLinkData = (props.link !== undefined && props.link !== "" && props.link.url !== undefined && props.link.url !== "");
	
    return (
		hasLinkData &&
        <a className={props.className} href={props.link.url}>
            {props.link.text}
            {props.children}
        </a>
    );
};

SitecoreLinkField.propTypes = {
	link : PropTypes.object,
    className: PropTypes.string
};

export default SitecoreLinkField;
